import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sendEmail" }
const _hoisted_2 = { class: "sendEmail__inputBox" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode()
const _hoisted_4 = /*#__PURE__*/_createVNode("label", null, "mail", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.email = $event))
      }, null, 512), [
        [_vModelText, _ctx.email]
      ]),
      _hoisted_3,
      _hoisted_4
    ]),
    _createVNode("div", null, [
      _createVNode("button", {
        class: "sendEmail__sendBtn",
        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.send(...args))),
        disabled: !_ctx.email
      }, " Отправить предложение ", 8, ["disabled"])
    ])
  ]))
}